import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=5388fb68&scoped=true&"
import script from "./Company.vue?vue&type=script&lang=js&"
export * from "./Company.vue?vue&type=script&lang=js&"
import style0 from "./Company.vue?vue&type=style&index=0&id=5388fb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5388fb68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
installComponents(component, {VLayout})
